/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyPlanController', DinghyPlanController);

    DinghyPlanController.$inject = ['dinghies', 'availableYears', 'currentProfile', '$state', '$scope','$sce', 'DinghyBoard', 'ParseLinks', 'AlertService', 'pagingParams', '$http', 'PrincipalProfile'];

    function DinghyPlanController(dinghies, availableYears, currentProfile, $state, $scope, $sce, DinghyBoard, ParseLinks, AlertService, pagingParams, $http, PrincipalProfile) {
        var vm = this;

        vm.timeFilter = pagingParams.timeFilter;
        vm.year = vm.timeFilter === 'active' || vm.timeFilter === 'archive' ? null : parseInt(vm.timeFilter);
        vm.dinghyIds = pagingParams.dinghyIds;

        vm.transition = transition;
        vm.loadAll = loadAll;
        vm.setFilter = setFilter;
        vm.anySelected = anySelected;
        vm.selectAll = selectAll;
        vm.selectNone = selectNone;
        vm.dinghies = dinghies;
        // set active states
        for (var index = 0; index < vm.dinghies.length; index++) {
            vm.dinghies[index].isSelected = vm.dinghyIds.includes('' + vm.dinghies[index].id) || vm.dinghyIds.length === 0 || vm.dinghyIds[0] == 0;
        }
        vm.availableYears = availableYears.data;
        vm.currentProfile = currentProfile;
        vm.dinghyEvents = [];

        loadAll();

        function loadAll () {
            $http.get('api/board/dinghies/overview', {
                params: {
                    timeFilter: vm.timeFilter,
                    dinghyIds: getDinghyIds()
                }
            }).then(function(response) {
                vm.dinghyEvents = response.data;
            });
        }

        function transition() {
            $state.transitionTo($state.$current, {
                timeFilter: vm.timeFilter,
                dinghyIds: getDinghyIds()
            });
        }

        function getDinghyIds() {
            var dinghyIds =  [];
            if (vm.dinghies.length === 0) {
                dinghyIds = vm.dinghyIds;
            } else {
                for (var index = 0; index < vm.dinghies.length; index++) {
                    if (vm.dinghies[index].isSelected) {
                        dinghyIds.push(vm.dinghies[index].id);
                    }
                }
            }
            if (dinghyIds.length === vm.dinghies.length) {
                dinghyIds = [0];
            }
            return dinghyIds.join(',');
        }

        function setFilter(filter) {
            vm.timeFilter = filter;
            vm.transition();
        }

        function anySelected() {
            for (var index = 0; index < vm.dinghies.length; index++) {
                if (vm.dinghies[index].isSelected) {
                    return true;
                }
            }
            return false;
        }

        function selectDinghy(value) {
            for (var index = 0; index < vm.dinghies.length; index++) {
                vm.dinghies[index].isSelected = value;
            }
        }

        function selectAll() {
            selectDinghy(true);
        }

        function selectNone() {
            selectDinghy(false);
        }
    }
})();
